import axios from "axios";

const loadAutomotorData = async (idCD, polkoClientes) => {
    let requestMarcas = process.env.REACT_APP_BACK_SERVER + '/getMarcasAutos'

    try {
        const response = await axios.get(requestMarcas, {
            params: {
                'idcanaldigital': idCD,
                ...(polkoClientes && { origen: "polko_clients" }),
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error loading automotor data:', error);
        throw error;
    }
};

export default loadAutomotorData;
